/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { FeatureSwagger } from 'src/luis/modules/features/types/FeatureSwagger';
import { FeatureStore } from 'src/luis/types/stores/features/FeatureStore';

/**
 * Converts the feature store to feature swagger type.
 *
 * @param param0.name The name of the feature.
 * @param param0.typeId The type of the feature.
 * @returns The swagger object.
 */
export const featureStoreToFeatureSwagger = ({
    name,
    typeId,
    isRequired
}: {
    name: string;
    typeId: FeatureStore['typeId'];
    isRequired: boolean;
}): FeatureSwagger => (typeId === 'feature' ? { featureName: name, isRequired } : { modelName: name, isRequired });
